"use strict";
// @ts-ignore
try {
    self['workbox:precaching:5.1.4'] && _();
}
catch (e) { }
